<template>
    <div>
        <h1 style="font-size: 24px; color: black;">事件管理</h1>
        <el-row>
            <el-col>
                <el-button type="primary" style="margin-bottom:10px;" @click="showAddEventDialog(0, '新增事件')">添加事件</el-button>
            </el-col>
        </el-row>
        <div>
            <el-table border
                      :data="eventList.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)">
                <el-table-column prop="popupId" label="功能ID"></el-table-column>
                <el-table-column prop="popupName" label="弹窗名称"></el-table-column>
                <el-table-column prop="id" label="事件ID"></el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">
                        <template v-if="scope.row.type===0">
                            弹窗
                        </template>
                        <template v-if="scope.row.type===1">
                            板块
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="事件名称"></el-table-column>
                <el-table-column label="日志虚拟PID" prop="whole"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="showAddEventDialog(1, '编辑事件', scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="addEventDialogVisible" center @close="closeAddEventDialog"
                       :close-on-click-modal="false">
                <el-form :model="addEventForm" ref="cateForm">
                    <el-form-item label="选择弹窗事件">
                        <el-radio v-model="radio" label='0'>弹窗</el-radio>
                        <el-radio v-model="radio" label='1'>事件</el-radio>
                    </el-form-item>
                    <el-form-item label="选择类型" v-if="radio ==='1'">
                        <el-radio v-model="addEventForm.type" :label='0'>事件</el-radio>
                        <el-radio v-model="addEventForm.type" :label='1'>板块</el-radio>
                    </el-form-item>
                    <el-form-item label="选择弹窗" v-if="radio ==='1' ">
                        <el-select v-model="addEventForm.popupId">
                            <el-option v-for="item in popupList" :key="item.id" :value="item.id" :label="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="名称">
                        <div v-if="radio==='0'">
                            <el-input v-model.trim="addEventForm.popupName" clearable></el-input>
                        </div>
                        <div v-if="radio==='1'">
                            <el-input v-model.trim="addEventForm.eventName" clearable></el-input>
                        </div>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                   <el-button type="primary" @click="confirmAddEventDialog">确 定</el-button>
                   <el-button type="info" @click="closeAddEventDialog">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <el-row>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum"
                :page-sizes="[1, 3,5,10]"
                :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next"
                :total="eventList.length">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
import {eventEdit, eventList, eventListEvent,} from "@/http/api"

export default {
    inject: ['reload'],
    name: "EventList",
    data() {
        return {
            radio: '0',
            dialogTitle: '',
            dialogType: 0,
            addEventDialogVisible: false,
            addEventForm: {
                popupId: '',
                eventId: 0,
                popupName: '',
                eventName: '',
                type: 0
            },
            eventList: [],
            popupList: [],
            queryInfo: {
                pagesize: 10,
                pagenum: 1,
            },
        };
    },

    methods: {
        showAddEventDialog(_type, _title, _data) {
            this.dialogType = _type;
            this.dialogTitle = _title;
            this.addEventForm = {
                popupId: '',
                eventId: 0,
                popupName: '',
                eventName: '',
                type: 0
            };
            if (_data) {
                this.radio = '1';
                this.addEventForm = {
                    popupName: _data.popupName,
                    popupId: _data.popupId,
                    eventId: _data.id,
                    eventName: _data.name,
                    type: _data.type
                }
            }
            this.addEventDialogVisible = true
        },
        closeAddEventDialog() {
            this.addEventDialogVisible = false;
            this.radio = '0'
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize;

        },
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage;

        },
        confirmAddEventDialog() {
            let _message = '';
            if (this.addEventForm.popupName === '' && this.addEventForm.eventName === '') {
                _message = '请填写名称'
            }
            if (this.radio === '1' && this.addEventForm.popupId === '') {
                _message = '请选择弹窗'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            let func = eventEdit;
            if (this.dialogType === 0) {
                if (this.radio === '0') {
                    func({
                        name: this.addEventForm.popupName,
                    }).then(resp => {

                        if (resp.data.status === 0) {
                            this.closeAddEventDialog()
                            this.$message({
                                message: '恭喜你，添加成功',
                                type: 'success'
                            });
                        }
                        this.reload();
                    }).catch(function () {
                    })
                } else {
                    func({
                        popupId: this.addEventForm.popupId,
                        eventName: this.addEventForm.eventName,
                        type: this.addEventForm.type
                    }).then(resp => {
                        this.reload();
                        if (resp.data.status === 0) {
                            this.closeAddEventDialog()
                        }
                    }).catch(function () {
                    })
                }
            }

            if (this.dialogType === 1) {
                if (this.radio === '0') {
                    func({
                        popupId: this.addEventForm.popupId,
                        name: this.addEventForm.popupName
                    }).then(resp => {
                        if (resp.data.status === 0) {
                            this.$message({
                                message: '恭喜你，编辑成功',
                                type: 'success'
                            });
                            this.closeAddEventDialog()
                        }
                        this.reload();
                    }).catch(function () {
                    })
                } else {
                    func({
                        popupId: this.addEventForm.popupId,
                        eventId: this.addEventForm.eventId,
                        eventName: this.addEventForm.eventName,
                        type: this.addEventForm.type
                    }).then(resp => {
                        this.reload();
                        if (resp.data.status === 0) {
                            this.closeAddEventDialog()
                        }
                    }).catch(function () {
                    })
                }
            }
        },
    },
    created() {
        eventListEvent().then(resp => {
            this.eventList = resp.data.info;
        });
        eventList().then(resp => {
            this.popupList = resp.data.info;
        });
    }
}
</script>

<style scoped>

</style>
